"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const boolToValue_1 = __importDefault(require("../lib/boolToValue"));
const listFormat_1 = __importDefault(require("../lib/listFormat"));
const listParse_1 = __importDefault(require("../lib/listParse"));
const registries_1 = require("../registries");
const arrayOperations = {
    concat(array, args) {
        return listFormat_1.default(array.concat(...listParse_1.default(args[2])));
    },
    slice(array, args) {
        let [l, r] = [parseInt(args[2]), parseInt(args[3])].map(a => isNaN(a) ? undefined : a);
        return listFormat_1.default(array.slice(l, r));
    },
    indexOf(array, args) {
        let index = parseInt(args[3]);
        index = isNaN(index) ? undefined : index;
        return array.indexOf(args[2], index).toString();
    },
    lastIndexOf(array, args) {
        let item = args[2];
        let index = parseInt(args[3]);
        index = isNaN(index) ? undefined : index;
        return array.indexOf(item, index).toString();
    },
    length(array) {
        return array.length.toString();
    },
    includes(array, args) {
        let item = args[2];
        let index = parseInt(args[3]);
        index = isNaN(index) ? undefined : index;
        return boolToValue_1.default(array.includes(item, index));
    },
    map(array, args, context) {
        if (typeof array == 'string') {
            array = array.split('');
        }
        return listFormat_1.default(array.map(v => {
            context.setVariable(args[2], v);
            return context.getValueOfVariable(args[3]);
        }));
    },
    join(array, args) {
        if (typeof array == 'string') {
            array = array.split('');
        }
        return array.join(args[2]);
    },
    split(array, args) {
        if (typeof array == 'string') {
            return listFormat_1.default(array.split(args[2]));
        }
        else {
            throw new TypeError('The operation "split" requires string.');
        }
    },
};
registries_1.functionRegistry.set('A', (context, args) => {
    let array = listParse_1.default(args[0]);
    let index = 0;
    if (!isNaN(index = parseInt(args[1]))) {
        if (typeof array == 'string') {
            throw new TypeError('The access operation requires list.');
        }
        else {
            return listFormat_1.default(array[index] = args[2]);
        }
    }
    else if (args[1] in arrayOperations) {
        return arrayOperations[args[1]](array, args, context);
    }
    else {
        throw new SyntaxError('Invalid operation.');
    }
});
